import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Tooltip} from "antd"

class JobStatistical extends Component {
    render() {
        const {item,} = this.props

        return (
            <div>
                <Tooltip title="Số items đang chờ">
                    <strong className="text-secondary">{item.jobs_pending_count}</strong>
                </Tooltip>/
                <Tooltip title="Số items đang generate">
                    <strong className="text-primary">{item.jobs_processing_count}</strong>
                </Tooltip>/
                <Tooltip title="Số items generate lỗi">
                    <strong className="text-danger">{item.jobs_error_count}</strong>
                </Tooltip>/
                <Tooltip title="Số items generate thành công">
                    <strong className="text-success">{item.jobs_done_count}</strong>
                </Tooltip>/
                <Tooltip title="Tổng số items generate">
                    <strong className="text-info">{item.jobs_count}</strong>
                </Tooltip>
            </div>
        )
    }
}

JobStatistical.propTypes = {
    item: PropTypes.object.isRequired,
}

export default JobStatistical